<template>
    <div
        :id="id"
        :class="classString"
        class="lni-u-reading-width--max"
    >
        <lni-spinner
            v-if="isLoading"
            :id="`${id}_spinner`"
            :inline="false"
        />
        <lni-child-labor-complaint-information
            :id="`${id}_information`"
            :text="text"
            @update-add="addTrackedErrors"
            @update-remove="removeTrackedErrors"
        />
        <lni-child-labor-complaint-employer
            :id="`${id}_employer`"
            classString="lni-u-mt2"
            :text="text"
            @update-add="addTrackedErrors"
        />
        <lni-child-labor-complaint-documents
            :id="`${id}_documents`"
            classString="lni-u-mt2"
            :text="text"
        />
        <lni-child-labor-complaint-contact
            :id="`${id}_contact`"
            classString="lni-u-mt2"
            :text="text"
            @update-add="addTrackedErrors"
            @update-remove="removeTrackedErrors"
        />
        <lni-checkbox
            :id="`${id}_certify`"
            class="lni-u-mt2"
            :labelText="text.attestation"
            :required="true"
            @change="onChange"
        />
        <div class="lni-u-pt3 lni-u-bt lni-u-b--subtle">
            <lni-error-container
                :id="`${id}_error-container`"
                class="lni-u-mb3"
                :errorsCollectedFrom="trackedErrors"
            />
            <lni-button
                :id="`${id}_submit`"
                :clickAction="['validateForm', `${id}/submit`]"
                :errorContainerId="`${id}_error-container`"
                class="lni-c-button --primary"
                :text="text.submit"
            />
        </div>
    </div>
</template>

<script>
export default {
    name : 'LniChildLaborComplaintForm',
    props: {
        classString: {
            type   : String,
            default: '',
        },
    },
    computed: {
        text() {
            return this.$store.state.appState?.text;
        },
    },
    mounted() {
        this.$store.commit(`${ this.id }/ADD_TRACKED_ERRORS`, [`${ this.id }_certify`]);
        this.$store.commit('setAttribute', {
            id       : `${ this.id }_error-container`,
            attribute: 'errorsCollectedFrom',
            value    : this.trackedErrors,
        });
    },
    methods: {
        addTrackedErrors($e) {
            this.$store.commit(`${ this.id }/ADD_TRACKED_ERRORS`, $e);
        },
        onChange() {
            const value = this.$store.state[`${ this.id }_certify`].checked;
            this.$store.dispatch('updateData', {
                key: 'attestation',
                value,
            });
        },
        removeTrackedErrors($e) {
            this.$store.commit(`${ this.id }/REMOVE_TRACKED_ERRORS`, $e);
        },
    },
};
</script>